(function(root) {
  const OVERSIZE_FEE_VARIANT_ID = 54089408839979;

  function toPositiveInteger(value, fallback) {
    const parsed = parseInt(value, 10);
    if (!Number.isFinite(parsed) || parsed < 1) return fallback;
    return parsed;
  }

  function collectLineItemProperties(formData) {
    const properties = {};

    formData.forEach((value, key) => {
      const match = key.match(/^properties\[(.+)\]$/);
      if (!match || value === '') return;
      properties[match[1]] = String(value);
    });

    return properties;
  }

  function buildOversizeCartAddPayload(formData, oversizeInput) {
    if (!formData || !oversizeInput || !oversizeInput.dataset) return null;

    const oversizeQuantity = toPositiveInteger(oversizeInput.value, 0);
    const feeVariantId = toPositiveInteger(oversizeInput.dataset.oversizeFeeVariantId, 0);
    if (!oversizeQuantity || !feeVariantId) return null;

    const bundleVariantId = toPositiveInteger(formData.get('id'), 0);
    const bundleQuantity = formData.has('quantity') ? toPositiveInteger(formData.get('quantity'), 0) : 1;
    if (!bundleVariantId || !bundleQuantity) return null;

    const bundleProperties = collectLineItemProperties(formData);
    bundleProperties['Oversize shirts 2XL-4XL'] = String(oversizeQuantity);

    const payload = {
      items: [
        {
          id: bundleVariantId,
          quantity: bundleQuantity,
          properties: bundleProperties
        },
        {
          id: feeVariantId,
          quantity: oversizeQuantity,
          properties: {
            '_oversize_fee_auto': 'true',
            '_oversize_fee_for_variant': String(bundleVariantId),
            'For bundle': oversizeInput.dataset.oversizeFeeFor || 'Custom Full Color Black T-Shirt Bundle'
          }
        }
      ]
    };

    const sections = formData.get('sections');
    const sectionsUrl = formData.get('sections_url');

    if (sections) payload.sections = String(sections);
    if (sectionsUrl) payload.sections_url = String(sectionsUrl);

    return payload;
  }

  function isAutoOversizeFeeLine(item) {
    return Number(item && item.variant_id) === OVERSIZE_FEE_VARIANT_ID
      && item.properties
      && item.properties['_oversize_fee_auto'] === 'true'
      && item.properties['_oversize_fee_for_variant'];
  }

  function getOrphanedOversizeFeeLineKeys(cartItems) {
    if (!Array.isArray(cartItems)) return [];

    const cartVariantIds = new Set(cartItems.map((item) => String(item.variant_id)));

    return cartItems
      .filter(isAutoOversizeFeeLine)
      .filter((item) => !cartVariantIds.has(String(item.properties['_oversize_fee_for_variant'])))
      .map((item) => item.key)
      .filter(Boolean);
  }

  function getCartSurface() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-items');
  }

  function removeOrphanedOversizeFees(cartData) {
    if (!root.routes || !root.routes.cart_change_url || !cartData || removeOrphanedOversizeFees.inFlight) return;

    const orphanKeys = getOrphanedOversizeFeeLineKeys(cartData.items);
    if (!orphanKeys.length) return;

    removeOrphanedOversizeFees.inFlight = true;

    const cartSurface = getCartSurface();
    const sections = cartSurface && typeof cartSurface.getSectionsToRender === 'function'
      ? cartSurface.getSectionsToRender().map((section) => section.id)
      : [];

    const body = {
      id: orphanKeys[0],
      quantity: 0
    };

    if (sections.length) {
      body.sections = sections;
      body.sections_url = window.location.pathname;
    }

    fetch(root.routes.cart_change_url, {
      ...fetchConfig(),
      body: JSON.stringify(body)
    })
      .then((response) => response.json())
      .then((response) => {
        if (cartSurface && typeof cartSurface.renderContents === 'function' && response.sections) {
          cartSurface.renderContents(response);
        } else {
          window.location.reload();
        }
      })
      .catch(() => {
        window.location.reload();
      })
      .finally(() => {
        removeOrphanedOversizeFees.inFlight = false;
      });
  }

  if (typeof document !== 'undefined') {
    document.addEventListener('afterUpdateQuantity', (event) => {
      removeOrphanedOversizeFees(event.detail && event.detail.cartData);
    });
  }

  const PrimitiveOversizeFee = {
    buildOversizeCartAddPayload,
    getOrphanedOversizeFeeLineKeys
  };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = PrimitiveOversizeFee;
  }

  root.PrimitiveOversizeFee = PrimitiveOversizeFee;
})(typeof window !== 'undefined' ? window : globalThis);
